// extracted by mini-css-extract-plugin
module.exports = {"display":"DateDisplay_display__2Pu3y"};